<script lang="ts" module>
    type Item = { title?: string } & ({ href?: string } | { snippet: Snippet });
    let breadcrumbs = $state<Item[]>([]);

    export function setBreadcrumbs(items: Item[]) {
        breadcrumbs = items;
    }
</script>

<script lang="ts">
    import Truncated from "./common/truncated.svelte";
    import * as Breadcrumb from "./ui/breadcrumb/index.js";
    import type { Snippet } from "svelte";
</script>

<svelte:head>
    <title
        >turian | {breadcrumbs
            .map(x => x.title)
            .filter(x => x)
            .join(" | ")}</title
    >
</svelte:head>

<Breadcrumb.Root>
    <Breadcrumb.List>
        {#each breadcrumbs as item, i (i)}
            {#if i > 0}
                <Breadcrumb.Separator />
            {/if}
            <Breadcrumb.Item class="h-9 text-base">
                {#if "snippet" in item}
                    {@render item.snippet()}
                {:else if !item.title}
                    <Breadcrumb.Ellipsis />
                {:else if i !== breadcrumbs.length - 1 && item.href}
                    <Breadcrumb.Link class="max-w-60 text-2xl font-bold" href={item.href}>
                        <Truncated value={item.title} />
                    </Breadcrumb.Link>
                {:else}
                    <Breadcrumb.Page class="max-w-60 text-2xl font-bold">
                        <Truncated value={item.title} />
                    </Breadcrumb.Page>
                {/if}
            </Breadcrumb.Item>
        {/each}
    </Breadcrumb.List>
</Breadcrumb.Root>
